export default __webpack_public_path__ + "static/media/sos-dia-10-11.39b1b6a5.webp";